import Contact from "./Contact.js";
import Hero from "../layout/Hero.js";
import I18n from "./locale/I18n.js";
import React from "react";
import TitleImage from "./TitleImage.js";

const Welcome = () => {
    return (
        <Hero
            actions={[<Contact key="contact" />]}
            image={<TitleImage />}
            title={<I18n label="WelcomeTitle" />}
            subtitle={<I18n label="WelcomeSubtitle" />}
        />
    );
};

export default Welcome;
